<template>
    <div>
        <div class="panel" :class="{ active: visibleNav }">

            <!-- Sidebar para Tablet / Desktkop -->
            <aside class="tablet-desktop">
                <div class="logo">
                    <router-link :to="{ name: 'app.dashboard' }">
                        <img v-if="company" :src="logotipo" alt="Dashboard" />
                    </router-link>
                </div>
                <nav class="menu">
                    <ul>
                        <!-- Exibindo o menu -->
                        <li v-for="(item, key) in menu.data" :class="{ active: (nav == item.route) }" :key="key">
                            <router-link :to="{ name: item.route }">
                                <font-awesome-icon :icon="item.icon" class="icon-big"/>
                                <br>
                                {{ item.title }}
                            </router-link>
                        </li>
                    </ul>
                </nav>
                <div class="version">
                    {{ version }}
                </div>
            </aside>

            <header>

                <!-- Mobile -->
                <div class="mobile">
                    <mu-row justify-content="center" align-items="center">
                        <mu-col span="10" sm="10" md="10" lg="10" xl="10">
                            <mu-flex justify-content="start" align-items="center">
                                <mu-button icon @click="drawer.open = !drawer.open">
                                    <font-awesome-icon icon="bars" class="icon-md"/>
                                </mu-button>
                                <span class="name" v-if="company">
                                    {{ company.name }}
                                </span>
                            </mu-flex>
                        </mu-col>
                        <mu-col span="2" sm="2" md="2" lg="2" xl="2">
                            <mu-button icon @click="goToRoute('app.profile')" class="float-right">
                                <font-awesome-icon icon="user" class="icon-md"/>
                            </mu-button>
                        </mu-col>
                    </mu-row>
                    <mu-drawer :open.sync="drawer.open" :docked="drawer.docked">
                        <div class="company">
                            <a href="javascript:;" @click="goToRoute('app.dashboard')">
                                <img v-if="company" :src="logotipo" alt="Dashboard" />
                            </a>
                            <p>{{ company.name }}</p>
                        </div>
                        <nav>
                            <!-- Exibindo o menu mobile -->
                            <li v-for="(item, key) in getMenuBottomNav()" :key="key" :class="{ active: (nav == item.route)}" class="li-mobile">
                                <a href="javascript:;" @click="goToRoute(item.route)" class="a-mobile">
                                    <font-awesome-icon :icon="item.icon" class="icon-sm icon-mobile"/>
                                    {{ item.title }}
                                </a>
                            </li>
                        </nav>
                        <div class="version">
                            {{ version }}
                        </div>
                        <div class="user">
                            <font-awesome-icon icon="user" class="icon-big"/>
                            <p>Olá, <strong>{{ firstName }}</strong></p>
                            <mu-button color="primary" round @click="logout()">
                                <font-awesome-icon icon="power-off" class="icon-sm icon-margin-left"/>
                                Sair
                            </mu-button>
                        </div>
                    </mu-drawer>
                </div>

                <!-- Tablet / Desktop -->
                <div class="tablet-desktop">
                    <mu-row justify-content="center" align-items="center">
                        <mu-col span="6" sm="6" md="6" lg="6" xl="6">
                            <div class="company">
                                <mu-flex justify-content="start" align-items="center">
                                    <mu-button icon @click="toggleNav()">
                                        <font-awesome-icon icon="bars" class="icon-md"/>
                                    </mu-button>
                                    <span class="name" v-if="company">
                                        {{ company.name }}
                                    </span>
                                </mu-flex>
                            </div>
                        </mu-col>
                        <mu-col span="6" sm="6" md="6" lg="6" xl="6">
                            <!-- Header do usuário -->
                            <mu-header-user></mu-header-user>
                        </mu-col>
                    </mu-row>
                </div>

            </header>

            <!-- Conteúdo -->
            <div class="wrapper">

                <!-- Main and Routes -->
                <main>

                    <!-- Alerta de conexão -->
                    <mu-alert color="error" v-if="!onLine">
                        <font-awesome-icon icon="ban" class="icon-lg icon-margin-left"/>
                        <div style="padding: 0 0 0 10px">Verifique sua conexão com a internet.</div>
                    </mu-alert>

                    <!-- Router View -->
                    <router-view name="authenticated"></router-view>
                </main>

            </div>
        </div>

        <!-- Menu Base APP -->
        <!-- <mu-bottom-nav :value.sync="shift" class="mobile" color="secondary">
            <mu-row justify-content="center" align-items="center">
                <mu-col span="4" sm="4" md="4" lg="4" xl="4" v-for="(item, key) in getMenuBottomNav()" :key="key">
                    <mu-bottom-nav-item :value="item.key" :title="item.title" :icon="item.icon" :to="{ name: item.route }"></mu-bottom-nav-item>
                </mu-col>
            </mu-row>
        </mu-bottom-nav> -->

        <!--
            Esses são eventos que podem ser chamados chamados em qualquer lugar da plataforma
            Ex.: this.$eventHub.$emit('loading', true, 'Aqui vai a mensagem para o loading.')
        -->

        <!-- Loading -->
        <mu-loading-dialog :message="loading.message" :visible="loading.visible"></mu-loading-dialog>

        <!-- Snackbar -->
        <mu-snackbar position="bottom-start" :color="snackbar.type" :open.sync="snackbar.open">
            {{ snackbar.message }}
            <mu-button flat slot="action" color="#fff" @click="snackbar.open = false">Fechar</mu-button>
        </mu-snackbar>

    </div>
</template>

<script>
    import menu from '@/config/menu'
    // import * as Sentry from '@sentry/browser'
    // import store from '@/store'
    import { version } from '@/../package.json'

    // ------------------------------------------------------------------------------------------

    // ╔═╗╔═╗╔╗╔╔╦╗╦═╗╦ ╦
    // ╚═╗║╣ ║║║ ║ ╠╦╝╚╦╝
    // ╚═╝╚═╝╝╚╝ ╩ ╩╚═ ╩

    // Configuração do sentry para logs do front
    // if (process.env.VUE_APP_SENTRY_DSN) {
    //     Sentry.init({
    //         dsn: process.env.VUE_APP_SENTRY_DSN,
    //         environment: process.env.NODE_ENV || 'development'
    //     })
    // }

    // ------------------------------------------------------------------------------------------

    export default {
        name: 'authenticated',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                version: `v.${version}`,
                shift: '',
                visibleNav: true,
                menu: menu,
                drawer: {
                    open: false,
                    docked: false
                },
                loading: {
                    message: '',
                    visible: false
                },
                snackbar: {
                    type: '',
                    message: '',
                    open: false,
                    timeout: 4000
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        /**
         * Praticamente todos os dados vem do state
         */
        computed: {
            expiration () {
                return this.$store.state.expiration
            },
            user () {
                return this.$store.state.user
            },
            company () {
                return this.$store.state.company
            },
            nav () {
                if (this.$route.name) {
                    let array = this.$route.name.split('.')
                    return `${array[0]}.${array[1]}`
                }
                return ''
            },
            onLine () {
                return this.$store.state.onLine
            },
            logotipo () {
                return this.$store.state.company.logo || '/img/logo-empty.jpg'
            },
            firstName () {
                return this.$store.state.user.firstName.substring(0, 15)
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted  () {
            // Iniciamos o layout com um refresh token caso ele apertar F5
            // antes de dar os 8 minutos para próximo refreshtoken
            this.refreshToken()

            // if (process.env.VUE_APP_SENTRY_DSN) {
            //     Sentry.configureScope(scope => {
            //         scope.setUser({
            //             ...this.$store.state.company,
            //             ...this.$store.state.user,
            //             version: version
            //         })
            //     })
            // }

            // Refresh token a cada 8 minutos
            setInterval(() => {
                this.refreshToken()
            }, 480000)

            // Evento loading
            this.$eventHub.$on('loading', (visible, message) => {
                this.loading.visible = visible
                this.loading.message = message || ''
            })

            // Evento snackbar
            this.$eventHub.$on('snackbar', (type, message, capture = true) => {
                this.snackbar.open = true
                this.snackbar.type = type
                this.snackbar.message = message
                setTimeout(() => {
                    this.snackbar.open = false
                }, this.snackbar.timeout)
                // if (type === 'error' && capture) {
                //     Sentry.captureException(new Error(message))
                // }
            })
        },

        // ╔╗ ╔═╗╔═╗╔═╗╦═╗╔═╗  ╔╦╗╔═╗╔═╗╔╦╗╦═╗╔═╗╦ ╦
        // ╠╩╗║╣ ╠╣ ║ ║╠╦╝║╣    ║║║╣ ╚═╗ ║ ╠╦╝║ ║╚╦╝
        // ╚═╝╚═╝╚  ╚═╝╩╚═╚═╝  ═╩╝╚═╝╚═╝ ╩ ╩╚═╚═╝ ╩

        /**
         * Destroy os eventos ao finalizar
         */
        beforeDestroy () {
            this.$eventHub.$off('loading')
            this.$eventHub.$off('snackbar')
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Habilita e desabilita a sidebar
             */
            toggleNav () {
                this.visibleNav = !this.visibleNav
            },

            /**
             * Direciona o item para uma rota
             */
            goToRoute (route) {
                this.drawer.open = false
                this.$router.push({ name: route }).catch(err => { if (err) console.log(err.name || '') })
            },

            /**
             * Faz o logout
             */
            logout () {
                this.$store.dispatch('logout').then((response) => {
                    this.$router.push({ name: 'auth.login' }).catch(err => { if (err) console.log(err.name || '') })
                }).catch((response) => {
                    this.$router.push({ name: 'auth.login' }).catch(err => { if (err) console.log(err.name || '') })
                })
            },

            /**
             * Faz o refresh token
             */
            refreshToken () {
                this.$store.dispatch('refreshToken').then((response) => {
                    if (response.code !== 200) {
                        this.logout()
                    }
                }).catch((response) => {
                    if (response.code !== 200) {
                        this.logout()
                    }
                })
            },

            /**
             * Faz um filtro do menu para não exibir o item dashboard
             * quando for um mobile
             */
            getMenuBottomNav () {
                return this.menu.data.filter((item) => {
                    return item.key !== 'dashboard'
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>

    /* Mobile First */

    @import './../assets/stylus/bootstrap.styl'

    .li-mobile
        width 75%
        margin-left 30px
        list-style-type none

    .a-mobile
        color #999
        padding 10px 0px
        font-size 12px
        display block
        border-bottom 1px #999 dotted
        // -webkit-box-shadow 2px 2px 4px 0px rgba(0, 0, 0, 0.15)
        // -moz-box-shadow 2px 2px 4px 0px rgba(0, 0, 0, 0.15)
        // box-shadow 2px 2px 4px 0px rgba(0, 0, 0, 0.15)
        margin 5px

    .icon-mobile
        margin-right 5px

    .mu-drawer
        border-radius 0
        width 70%

        .company
            text-align center
            padding 15px 10px

            p
                font-size 16px
                font-weight bold

            img
                max-width 100%
                max-height 80px

        .user
            position absolute
            left 0
            right 0
            bottom 0
            padding 20px
            text-align center
            color #999
            font-size 12px
            p
                margin 0 0 5px 0
            strong
                color #777

    .mu-bottom-nav
        background-gradiente(darken($primary, 35%), $primary)

        position fixed
        bottom -2px
        width 100%
        z-index 100
        color #fff
        height 70px

        .mu-row
            width 100%

        .mu-bottom-item
            padding-top 12px !important
            padding 0 20px
            display inline-block

            &.router-link-active, &.router-link-exact-active, &.mu-bottom-item-active
                color #fff

                .mu-bottom-item-text
                    font-size 12px !important

    .tablet-desktop
        display none

    .version
        position fixed
        bottom 5px
        color #666
        left 5px
        text-align center
        font-size 11px

    .panel
        color #666

        header
            background-gradiente(darken($primary, 40%), $primary)
            color #ffffff
            font-size 14px

        .wrapper
            main
                padding 10px 10px 70px 10px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .mu-bottom-nav
            background-gradiente(darken($secondary, 8%), $primary)

        .panel

            header
                background-gradiente(darken($secondary, 10%), $primary)

            &.active

                aside
                    display block
                    width 160px

                header
                    padding-left 160px
                    font-size 13px

                .wrapper
                    padding-left 160px

            aside
                display none
                background #fff
                height 100vh
                border-right 1px #e7e7e7 solid
                position fixed
                z-index 400

                box-shadow(right, 3px, 8px, 0.05)

                .logo
                    text-align center
                    padding 15px 10px
                    border-bottom 1px #bbb dotted

                    img
                        max-width 100%
                        max-height 60px

                nav
                    text-align center
                    padding 10px 0

                    ul
                        margin 0
                        padding 0

                        li
                            list-style none
                            border-right 3px #fff solid
                            transition all 0.4s

                            a
                                display block
                                padding 15px 10px
                                color #888
                                line-height 14px
                                font-family $fontFamily
                                font-size 12px
                                text-transform uppercase
                                transition all 0.4s

                                svg
                                    font-size 26px
                                    margin-bottom 8px

                            &:hover
                                border-right 3px #ccc solid
                                a
                                    background #f5f5f5

                            &.active
                                border-right 3px $primary solid
                                a
                                    background #f5f5f5
                                    .icon
                                        color $primary

            header
                padding 4px 0
                position fixed
                width 100%
                z-index 300

                .company
                    padding-left 10px

                .user-header
                    padding-right 10px

                    ul
                        li
                            display inline

                    .notifications-number
                        background $red
                        color #fff
                        border-radius 50px
                        font-size 10px
                        position relative
                        padding 2px
                        height 20px
                        width 20px
                        top -16px
                        right -30px

                .user
                    text-align right
                    padding-right 10px
                    line-height 36px
                    font-family $fontFamily
                    color rgba(255, 255, 255, 0.7)

                    .notifications-number
                        background $red
                        color #fff
                        border-radius 50px
                        font-size 10px
                        position relative
                        padding 2px
                        height 20px
                        width 20px
                        top -16px
                        right -30px

                    strong
                        padding 0 10px
                        color #fff

                    .color-opacity
                        color rgba(255, 255, 255, 0.7)

                    a
                        margin-left 2px

            .wrapper
                main
                    padding 70px 15px 15px 15px

        .tablet-desktop
            display block

        .mobile
            display none

    /* Desktop >= 1024 pixels */
    @media (min-width: 1024px)

        .panel

            .wrapper

                main
                    padding 70px 30px 15px 30px

</style>
